import { memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import dayjs from 'dayjs';
import { useAnalytics } from 'use-analytics';
import DateFilter from '../../../../Filters/DateSelectorFilter';
import { hotelSearch } from '../../../../../store/slices/hotel';
import { setHotelTripSearchInputs } from '../../../../../store/slices/tripSearch';
import { getTravelPolicyLeadDays } from '../../../../../store/slices/user';
import { TravelTypes } from '../../../../../constants';

const CheckOutDateFilter = ({
  tripId, doOpenDatePicker, setDoOpenDatePicker, bgClassName,
}) => {
  const dispatch = useDispatch();
  const { track } = useAnalytics();
  const isHotelTripSearch = !tripId;
  const {
    searchObj = {},
    defaultSearchObj = {},
  } = useSelector((store) => store.hotel.hotelSearches[tripId] || {});

  const hotelTripSearchInputs = useSelector((store) => store.tripSearch.searchInputs.hotel);
  const leadDays = useSelector(getTravelPolicyLeadDays(TravelTypes.hotel));
  const value = isHotelTripSearch ? hotelTripSearchInputs.checkOutDate : searchObj.checkOutDate;
  const checkInDate = isHotelTripSearch ? hotelTripSearchInputs.checkInDate : searchObj.checkInDate;
  const defaultValue = isHotelTripSearch ? hotelTripSearchInputs.checkOutDate
    : defaultSearchObj.checkOutDate;

  const handleChange = (newValue) => {
    if (newValue) {
      setDoOpenDatePicker(false);
    }
    const payload = {
      tripId,
      searchObj: {
        page: 1,
        checkOutDate: newValue,
      },
    };
    if (isHotelTripSearch) {
      dispatch(setHotelTripSearchInputs({ ...payload.searchObj }));
    } else {
      dispatch(hotelSearch(payload));
    }
    track('hotelCheckOutDate.handleChange', {
      checkoutDate: newValue,
    });
  };

  return (
    <DateFilter
      onChange={handleChange}
      label={value ? 'Check-out' : 'Check-out Date'}
      value={value}
      minDate={dayjs(checkInDate).add(1, 'day')}
      defaultValue={defaultValue}
      variant={isHotelTripSearch ? 'outline-no-radius' : 'outline'}
      filterButtonMaxWidth={clsx('max-w-full', { 'w-full': isHotelTripSearch })}
      doOpenDatePicker={doOpenDatePicker}
      setDoOpenDatePicker={setDoOpenDatePicker}
      bgClassName={!isHotelTripSearch ? '' : bgClassName}
      textColorClassName="text-datepicker-0"
      leadDays={leadDays}
    />
  );
};

CheckOutDateFilter.propTypes = {
  tripId: PropTypes.string,
  doOpenDatePicker: PropTypes.bool,
  setDoOpenDatePicker: PropTypes.func,
  bgClassName: PropTypes.string,
};

CheckOutDateFilter.defaultProps = {
  tripId: undefined,
  doOpenDatePicker: false,
  setDoOpenDatePicker: () => { },
  bgClassName: undefined,
};

export default memo(CheckOutDateFilter);
